export const isClient = (): boolean => typeof window !== "undefined";
